/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import {
  GET_PROVISIONED_APPLICATIONS,
  GET_USER_INFO,
  HAS_JOURNEY_BUILDER_ACCESS,
  HAS_AUTOMATION_STUDIO_ACCESS,
  HAS_EMAIL_STUDIO_ACCESS,
  HAS_EMAIL_STUDIO_TRACKING_ACCESS,
  HAS_CONTENT_BUILDER_ACCESS,
  HAS_ADMINISTRATION_ACCESS,
} from '../constants';

import { createMcProvisionedApplicationsAction, createMcUserInfoAction, createMcHasPermissionAction } from '../api';

export function getProvisionedApplications() {
  return createMcProvisionedApplicationsAction(GET_PROVISIONED_APPLICATIONS);
}

export function hasJourneyBuilderAccessPermission() {
  return createMcHasPermissionAction(HAS_JOURNEY_BUILDER_ACCESS, 'InteractionStudio', 'Access');
}

export function hasAutomationStudioAccessPermission() {
  return createMcHasPermissionAction(HAS_AUTOMATION_STUDIO_ACCESS, 'AutomationStudio', 'Access');
}

export function hasEmailStudioAccessPermission() {
  return createMcHasPermissionAction(HAS_EMAIL_STUDIO_ACCESS, 'Email', 'View');
}

export function hasEmailStudioTrackingAccessPermission() {
  return createMcHasPermissionAction(HAS_EMAIL_STUDIO_TRACKING_ACCESS, 'Tracking', 'View');
}

export function hasContentBuilderAccessPermission() {
  return createMcHasPermissionAction(HAS_CONTENT_BUILDER_ACCESS, 'Assets', 'View');
}

export function getUserInfo() {
  return createMcUserInfoAction(GET_USER_INFO);
}

export function hasAdministrationAccessPermission() {
  return createMcHasPermissionAction(HAS_ADMINISTRATION_ACCESS, 'Administration', 'Access');
}
